import ky from 'ky';
import { generateJwt } from './services/generate-jwt';

/**
 * Shared ky HTTP client instance.
 * - Prefixes all requests with the API Gateway URL from env vars.
 * - Attaches the Cognito ID token as a Bearer token on every request.
 * - Detects 401 responses and redirects to re-authenticate.
 */
export const api = ky.create({
  prefixUrl: import.meta.env.VITE_API_GW_URL,
  retry: 0, // Let TanStack Query handle retries
  hooks: {
    beforeRequest: [
      async (request) => {
        const jwt = await generateJwt();
        if (jwt) {
          request.headers.set('Authorization', `Bearer ${jwt}`);
        }
      },
    ],
    afterResponse: [
      async (_request, _options, response) => {
        if (response.status === 401) {
          // Session expired — redirect to re-authenticate
          window.location.href = '/';
        }
      },
    ],
  },
});
